import React, { Component } from "react";
import { Route, Switch, BrowserRouter } from "react-router-dom";
// Styles
import "./scss/style.css";
import "flag-icon-css/css/flag-icon.min.css";
import "font-awesome/css/font-awesome.min.css";
import "simple-line-icons/css/simple-line-icons.css";
import "./css/loaderComponent.css";
// Containers
import DefaultLayout from "./containers/DefaultLayout/DefaultLayout";
import { Page404 } from "./views/Pages";
import { NewsWebViews } from "./views/Pages";
import LspLogin from "./containers/LspLogin";
import Login from "./containers/Login";
import MultiRole from "./containers/MultiRole";
import ForgotPassword from "./containers/ForgotPassword";
import Register from "./views/Register/Register";
import Logout from "./containers/Logout";
import Confirm from "./views/Register/Confirm";

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      logged_id: undefined,
    };
  }

  componentDidMount() {}

  handleNewUserMessage = (newMessage) => {
    console.log(`New message incomig! ${newMessage}`);
  };

  render() {
    return (
      <div className="App">
        {/* <BrowserRouter history={history}> */}

        <BrowserRouter>
          <Switch>
            <Route path="/404" component={Page404} />
            <Route path="/articles/:article_id" component={NewsWebViews} />
            <Route path="/register" component={Register} />
            <Route path="/confirm" component={Confirm} />
            <Route path="/login" name="Login" component={Login} />
            <Route path="/logout" name="logout" exact={true} component={Logout} />
            <Route path="/lsplogin" name="Login" component={LspLogin} />
            <Route path="/multi-role" name="Login" component={MultiRole} />
            <Route
              path="/forgot-password"
              name="Login"
              component={ForgotPassword}
            />
            <Route path="/" name="Home" component={DefaultLayout} />
          </Switch>
        </BrowserRouter>
      </div>
    );
  }
}

export default App;
